import BaseClient from '@/app/model/api/response/baseApiClient'

class GetLinkImgApi extends BaseClient {
  public getLinkImgData () {
    const path = '/v1/file/planting-link-icon'
    var url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.blob()
    } else {
      throw Error(response.status)
    }
  }

  public getPayload (data: any) {
    const outside: any = URL.createObjectURL(data)
    return outside
  }
}

export default new GetLinkImgApi()
